/* Glitterfox review form: opened from the link in the review request mail (?t=TOKEN, optional &r=STARS).
   Talks to the review server (data-api on #gf-rvform). Plain JS, no dependencies. */
(function () {
  var root = document.getElementById('gf-rvform');
  if (!root) return;

  var qs = new URLSearchParams(window.location.search);
  var token = qs.get('t') || '';
  var api = (root.getAttribute('data-api') || '').replace(/\/$/, '');
  var override = qs.get('api');
  if (override && /^http:\/\/localhost:\d+$/.test(override)) api = override;
  var shopUrl = root.getAttribute('data-shop') || '/';
  var openedAt = Date.now();
  var LABELS = ['', 'Dårlig', 'Ikke så god', 'Okay', 'God', 'Fremragende'];
  var MONTHS = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];

  var data = null;
  var st = { mode: 'all', blocks: [], name: '', anonymous: false, busy: false, error: '' };

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fetchJson(path, opts) {
    return fetch(api + path, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (j) {
        if (!res.ok) { var e = new Error(j.error || 'Fejl'); e.status = res.status; throw e; }
        return j;
      });
    });
  }

  function show(html) {
    root.innerHTML = html;
    root.classList.add('is-ready');
  }

  function message(title, text, extra) {
    show('<div class="gf-rf__card gf-rf__card--msg"><h2 class="gf-rf__h">' + esc(title) + '</h2><p class="gf-rf__p">' + esc(text) + '</p>' + (extra || '') +
      '<a class="gf-rf__btn" href="' + esc(shopUrl) + '">Til Glitterfox.dk</a></div>');
  }

  // ----- unsubscribe -------------------------------------------------------
  function unsubscribeView() {
    show('<div class="gf-rf__card gf-rf__card--msg"><h2 class="gf-rf__h">Afmeld anmeldelsesmails</h2>' +
      '<p class="gf-rf__p">Vil du ikke have flere mails fra os om at skrive anmeldelser? Så trykker du bare på knappen.</p>' +
      '<button type="button" class="gf-rf__btn" id="gf-rf-unsub">Ja, afmeld mig</button></div>');
    document.getElementById('gf-rf-unsub').addEventListener('click', function () {
      this.disabled = true;
      fetchJson('/api/public/unsubscribe', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ t: token }) })
        .then(function () { message('Du er afmeldt', 'Du får ikke flere mails fra os om at skrive anmeldelser.'); })
        .catch(function () { message('Noget gik galt', 'Prøv igen om lidt, eller skriv til info@glitterfox.dk.'); });
    });
  }

  // ----- form ---------------------------------------------------------------
  function productChips(ids) {
    return ids.map(function (id) {
      var p = data.products.filter(function (x) { return x.id === id; })[0];
      if (!p) return '';
      return '<span class="gf-rf__prod">' + (p.image ? '<img' + (st.rendered ? '' : ' class="js-img-fade js-paint-fade" onload="window.gfFadeIn?gfFadeIn(this):this.classList.add(\'is-loaded\')" onerror="this.classList.add(\'is-loaded\')"') + ' src="' + esc(p.image) + '&width=96" alt="" width="40" height="40" loading="lazy">' : '') +
        '<span>' + esc(p.title) + '</span></span>';
    }).join('');
  }

  function buildBlocks() {
    var all = data.products.map(function (p) { return p.id; });
    var keep = st.blocks;
    if (st.mode === 'split') {
      st.blocks = all.map(function (id, i) {
        var old = keep[i] || keep[0] || {};
        return { productIds: [id], rating: old.rating || 0, title: '', body: '', photos: [] };
      });
    } else {
      var first = keep[0] || {};
      st.blocks = [{ productIds: all, rating: first.rating || 0, title: first.title || '', body: first.body || '', photos: first.photos || [] }];
    }
  }

  // The hint in the text field only talks about the glitter when every product in the review is a glimmer product.
  function bodyHint(ids) {
    var glimmer = ids.length > 0 && ids.every(function (id) {
      var p = data.products.filter(function (x) { return x.id === id; })[0];
      return p && /glimmer/i.test(p.title);
    });
    return 'Hvordan er pasformen, komforten og ' + (glimmer ? 'glimmereffekten' : 'kvaliteten') + '? Fortæl gerne, hvad du synes, efter du har prøvet dem.';
  }

  function blockHtml(b, i) {
    var stars = '';
    for (var n = 1; n <= 5; n++) {
      stars += '<label class="gf-rf__star" title="' + LABELS[n] + '"><input type="radio" name="rating-' + i + '" value="' + n + '"' + (b.rating === n ? ' checked' : '') +
        '><svg class="gf-rf__sv" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.2 1.2-6.5L2.5 9.5l6.6-.9z"/></svg><span class="gf-rf__sr">' + n + ' stjerner, ' + LABELS[n] + '</span></label>';
    }
    var photos = b.photos.map(function (src, k) {
      return '<span class="gf-rf__ph"><img src="' + src + '" alt="Dit billede"><button type="button" data-rm="' + k + '" aria-label="Fjern billede">&times;</button></span>';
    }).join('');
    var canAdd = data.maxPhotos > 0 && b.photos.length < data.maxPhotos;
    return '<div class="gf-rf__block" data-i="' + i + '" role="group" aria-labelledby="gf-rf-lg-' + i + '">' +
      '<div class="gf-rf__prods">' + productChips(b.productIds) + '</div>' +
      '<p class="gf-rf__legend" id="gf-rf-lg-' + i + '">Hvor mange stjerner vil du give?</p>' +
      '<div class="gf-rf__stars" data-v="' + (b.rating || 0) + '" role="radiogroup">' + stars + '</div>' +
      '<div class="gf-rf__rtext" aria-live="polite">' + (b.rating ? LABELS[b.rating] : '') + '</div>' +
      '<label class="gf-rf__lab" for="gf-rf-title-' + i + '">Overskrift <span>(valgfri)</span></label>' +
      '<input class="gf-rf__in" id="gf-rf-title-' + i + '" type="text" maxlength="100" value="' + esc(b.title) + '" placeholder="Hvad er dit første indtryk?">' +
      '<label class="gf-rf__lab" for="gf-rf-body-' + i + '">Fortæl os, hvad du synes</label>' +
      '<textarea class="gf-rf__in gf-rf__ta" id="gf-rf-body-' + i + '" rows="5" maxlength="2000" placeholder="' + esc(bodyHint(b.productIds)) + '">' + esc(b.body) + '</textarea>' +
      (data.maxPhotos > 0
        ? '<div class="gf-rf__photos">' + photos +
          (canAdd ? '<button type="button" class="gf-rf__add" data-add="1"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8.5A1.5 1.5 0 0 1 5.5 7H8l1.2-2h5.6L16 7h2.5A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5z"/><circle cx="12" cy="13" r="3.4"/></svg>Tilføj billede <em>(valgfrit)</em></button>' +
            (data.reward && data.reward.percentPhoto > data.reward.percent ? '<span class="gf-rf__addhint">+' + (data.reward.percentPhoto - data.reward.percent) + ' % ekstra rabat med billede</span>' : '') : '') +
          '<input type="file" accept="image/*" multiple hidden></div>'
        : '') +
      '</div>';
  }

  function formHtml() {
    var rewardTxt = '';
    if (data.reward) {
      rewardTxt = '<div class="gf-rf__reward"><span class="gf-rf__gift" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3.5" y="9" width="17" height="4.2" rx="1"/><path d="M5 13.2V20h14v-6.8M12 9v11M12 9c-1.2-3.8-5.4-4.4-5.4-1.9 0 1.5 2 1.9 5.4 1.9zM12 9c1.2-3.8 5.4-4.4 5.4-1.9 0 1.5-2 1.9-5.4 1.9z"/></svg></span><p class="gf-rf__rt"><strong>Få ' + data.reward.percent + ' % rabat</strong> på din næste ordre, når du har skrevet en anmeldelse' +
        (data.maxPhotos > 0 ? ' (' + data.reward.percentPhoto + ' % hvis du tilføjer et billede)' : '') + '.</p><svg class="gf-rf__sp gf-rf__sp1" aria-hidden="true"><use href="#gfi-sparkle"></use></svg><svg class="gf-rf__sp gf-rf__sp2" aria-hidden="true"><use href="#gfi-sparkle"></use></svg></div>';
    }
    var split = data.products.length > 1
      ? '<div class="gf-rf__mode"><label><input type="radio" name="mode" value="all"' + (st.mode === 'all' ? ' checked' : '') + '> Én anmeldelse til alle</label>' +
        '<label><input type="radio" name="mode" value="split"' + (st.mode === 'split' ? ' checked' : '') + '> Anmeld hvert produkt for sig</label></div>'
      : '';
    return '<form class="gf-rf__card' + (st.rendered ? '' : ' gf-rf__card--in') + '" novalidate>' +
      '<h2 class="gf-rf__h">Hej ' + esc(data.firstName || 'du') + '!</h2>' +
      '<p class="gf-rf__p">Hvordan var dine strømper? <span class="gf-rf__hrt" role="img" aria-label="hjerte"></span></p>' +
      split +
      '<div class="gf-rf__blocks">' + st.blocks.map(blockHtml).join('<div class="gf-rf__orn" aria-hidden="true"><i></i><svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="#D96F7A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20.6l-1.3-1.2C5.9 15 3 12.4 3 9.1 3 6.5 5 4.5 7.6 4.5c1.7 0 3.3.8 4.4 2.1 1.1-1.3 2.7-2.1 4.4-2.1C19 4.5 21 6.5 21 9.1c0 3.3-2.9 5.9-7.7 10.3L12 20.6z"/></svg><i></i></div>') + '</div>' +
      '<div class="gf-rf__name"><label class="gf-rf__lab" for="gf-rf-name">Dit navn på anmeldelsen</label>' +
      '<input class="gf-rf__in" id="gf-rf-name" type="text" maxlength="40" value="' + esc(st.name) + '"' + (st.anonymous ? ' disabled' : '') + '>' +
      '<label class="gf-rf__chk"><input type="checkbox" id="gf-rf-anon"' + (st.anonymous ? ' checked' : '') + '> Vis mig som anonym</label></div>' +
      '<input type="text" name="website" tabindex="-1" autocomplete="off" class="gf-rf__hp" aria-hidden="true">' +
      '<div class="gf-rf__err" role="alert">' + esc(st.error) + '</div>' +
      rewardTxt +
      '<button type="submit" class="gf-rf__btn"' + (st.busy ? ' disabled' : '') + '>' + (st.busy ? 'Sender...' : 'Udgiv din anmeldelse') + '</button>' +
      '<p class="gf-rf__fine">Din anmeldelse vises på glitterfox.dk sammen med dit navn. Din mailadresse vises aldrig.</p>' +
      '</form>';
  }

  function renderForm() {
    show(formHtml());
    st.rendered = true;
    var form = root.querySelector('form');

    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    Array.prototype.forEach.call(form.querySelectorAll('input[name="mode"]'), function (r) {
      r.addEventListener('change', function () { st.mode = r.value; buildBlocks(); renderForm(); });
    });
    var anon = document.getElementById('gf-rf-anon');
    anon.addEventListener('change', function () {
      st.anonymous = anon.checked;
      document.getElementById('gf-rf-name').disabled = anon.checked;
    });
    document.getElementById('gf-rf-name').addEventListener('input', function (e) { st.name = e.target.value; });

    Array.prototype.forEach.call(form.querySelectorAll('.gf-rf__block'), function (el) {
      var i = Number(el.getAttribute('data-i'));
      var b = st.blocks[i];
      Array.prototype.forEach.call(el.querySelectorAll('input[type=radio]'), function (r) {
        r.addEventListener('change', function () {
          b.rating = Number(r.value);
          el.querySelector('.gf-rf__stars').setAttribute('data-v', String(b.rating));
          el.querySelector('.gf-rf__rtext').textContent = LABELS[b.rating];
        });
      });
      el.querySelector('input[type=text]').addEventListener('input', function (e) { b.title = e.target.value; });
      el.querySelector('textarea').addEventListener('input', function (e) { b.body = e.target.value; });
      var file = el.querySelector('input[type=file]');
      var add = el.querySelector('[data-add]');
      if (add && file) {
        add.addEventListener('click', function () { file.click(); });
        file.addEventListener('change', function () { addPhotos(b, file.files); });
      }
      Array.prototype.forEach.call(el.querySelectorAll('[data-rm]'), function (btn) {
        btn.addEventListener('click', function () { b.photos.splice(Number(btn.getAttribute('data-rm')), 1); renderForm(); });
      });
    });
  }

  // Resize in the browser: small upload, and re-encoding drops the location data in the photo.
  function shrink(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var max = 1600;
        var w = img.naturalWidth, h = img.naturalHeight;
        var s = Math.min(1, max / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * s); c.height = Math.round(h * s);
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
        ctx.drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        var q = 0.84, out = c.toDataURL('image/jpeg', q);
        while (out.length > 2400000 && q > 0.4) { q -= 0.12; out = c.toDataURL('image/jpeg', q); }
        resolve(out);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('read')); };
      img.src = url;
    });
  }

  function addPhotos(block, files) {
    var list = Array.prototype.slice.call(files || []);
    var room = data.maxPhotos - block.photos.length;
    list = list.slice(0, Math.max(0, room));
    if (!list.length) return;
    st.error = '';
    Promise.all(list.map(function (f) { return shrink(f).catch(function () { return null; }); })).then(function (res) {
      var ok = res.filter(Boolean);
      if (ok.length < res.length) st.error = 'Et af billederne kunne ikke bruges. Prøv et JPEG- eller PNG-billede.';
      block.photos = block.photos.concat(ok);
      renderForm();
    });
  }

  function submit() {
    if (st.busy) return;
    var tooShort = false, noStars = false;
    st.blocks.forEach(function (b) {
      if (!b.rating) noStars = true;
      if ((b.body || '').trim().length < data.minChars) tooShort = true;
    });
    if (noStars) { st.error = 'Vælg antal stjerner.'; return renderForm(); }
    if (tooShort) { st.error = 'Skriv et par ord om dine strømper.'; return renderForm(); }
    st.busy = true; st.error = '';
    renderForm();
    var hp = root.querySelector('.gf-rf__hp');
    var body = {
      t: token, name: st.name, anonymous: st.anonymous, elapsed: Math.round((Date.now() - openedAt) / 1000),
      website: hp ? hp.value : '',
      reviews: st.blocks.map(function (b) {
        return { productIds: b.productIds, rating: b.rating, title: b.title, body: b.body, photos: b.photos };
      }),
    };
    fetchJson('/api/public/review', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) { thanks(res, body); })
      .catch(function (e) {
        st.busy = false;
        st.error = e.status === 409 ? 'Du har allerede skrevet en anmeldelse. Tak!' : (e.message || 'Noget gik galt. Prøv igen om lidt.');
        renderForm();
      });
  }

  function dkDate(iso) {
    var d = new Date(iso);
    return d.getDate() + '. ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  var STAR_D = 'M12 2.6l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.2 1.2-6.5L2.5 9.5l6.6-.9z';
  var HEART_SVG = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="#D96F7A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20.6l-1.3-1.2C5.9 15 3 12.4 3 9.1 3 6.5 5 4.5 7.6 4.5c1.7 0 3.3.8 4.4 2.1 1.1-1.3 2.7-2.1 4.4-2.1C19 4.5 21 6.5 21 9.1c0 3.3-2.9 5.9-7.7 10.3L12 20.6z"/></svg>';
  var GIFT_SVG = '<svg viewBox="0 0 48 48" aria-hidden="true"><rect x="6" y="18" width="36" height="9" rx="2"/><path d="M9 27v15h30V27M24 18v24M24 18c-2.4-8-11.4-9.4-11.4-4.2 0 3.2 4.2 4.2 11.4 4.2zM24 18c2.4-8 11.4-9.4 11.4-4.2 0 3.2-4.2 4.2-11.4 4.2z"/><path d="M12 5.5l2.2 3.2M36 5.5l-2.2 3.2M24 2.5v4" /></svg>';
  var COPY_SVG = '<svg class="gf-ty__ci" viewBox="0 0 24 24" aria-hidden="true"><rect x="8.5" y="8.5" width="11" height="11" rx="2"/><path d="M15.5 8.5V6.5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2"/></svg>';
  var TP_URL = 'https://dk.trustpilot.com/evaluate/glitterfox.dk';
  var ARROW_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';

  function spark(cls) {
    return '<svg class="gf-ty__sp ' + cls + '" aria-hidden="true"><use href="#gfi-sparkle"></use></svg>';
  }
  function starRow(n) {
    var h = '';
    for (var i = 1; i <= 5; i++) h += '<svg class="gf-ty__st' + (i <= n ? ' on' : '') + '" viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR_D + '"/></svg>';
    return h;
  }
  function productNames(ids) {
    return ids.map(function (id) {
      var p = data.products.filter(function (x) { return x.id === id; })[0];
      return p ? p.title : '';
    }).filter(Boolean).join(', ');
  }

  function thanks(res, sent) {
    var wrap = root.closest ? root.closest('.gf-rp') : null;
    if (wrap) wrap.classList.add('is-thanks');
    var published = res.status === 'published';
    var who = st.anonymous ? '' : (st.name || data.firstName || '').trim();
    var head = 'Tusind tak for din anmeldelse' + (who ? ', ' + esc(who) : '') + '!';
    var lead = '<span>Din mening betyder mere, end du tror.</span> ' +
      '<span>' + (published ? 'Din anmeldelse er nu på siden og hjælper andre med at finde deres nye favoritter.' : 'Din anmeldelse bliver lige gennemset og kommer på siden hurtigst muligt.') + '</span> ' +
      '<span>Det sætter vi stor pris på!</span>';

    // the stars the customer actually gave
    var reviews = (sent && sent.reviews) || [];
    var rate = '';
    if (reviews.length === 1) {
      var n = Number(reviews[0].rating) || 0;
      rate = '<div class="gf-ty__rate">' + spark('gf-ty__sp-a') + spark('gf-ty__sp-b') + spark('gf-ty__sp-c') + spark('gf-ty__sp-d') +
        '<div class="gf-ty__stars" role="img" aria-label="' + n + ' ud af 5 stjerner">' + starRow(n) + '</div>' +
        '<p class="gf-ty__rl">Din vurdering</p><p class="gf-ty__rv">' + n + ' ud af 5 stjerner</p></div>';
    } else if (reviews.length > 1) {
      rate = '<div class="gf-ty__rate gf-ty__rate--multi"><p class="gf-ty__rl">Din vurdering</p><ul class="gf-ty__list">' + reviews.map(function (r) {
        var n2 = Number(r.rating) || 0;
        return '<li><span class="gf-ty__pn">' + esc(productNames(r.productIds || [])) + '</span><span class="gf-ty__ps" role="img" aria-label="' + n2 + ' ud af 5 stjerner">' + starRow(n2) + '</span><span class="gf-ty__pv">' + n2 + ' ud af 5</span></li>';
      }).join('') + '</ul></div>';
    }

    // the discount, only the real numbers
    var coupon = '';
    if (res.coupon) {
      coupon = '<div class="gf-ty__coupon">' + spark('gf-ty__sp-e') + spark('gf-ty__sp-f') +
        '<div class="gf-ty__left"><div class="gf-ty__big"><span class="gf-ty__gift">' + GIFT_SVG + '</span>' +
        '<span class="gf-ty__pct"><span class="gf-ty__num">' + esc(res.coupon.percent) + '</span><span class="gf-ty__sign">%</span></span></div>' +
        '<p class="gf-ty__sub">Rabat på din næste ordre</p></div>' +
        '<div class="gf-ty__sepv" aria-hidden="true"></div>' +
        '<div class="gf-ty__right"><p class="gf-ty__cl">Din rabatkode</p>' +
        '<button type="button" class="gf-ty__code" id="gf-rf-copy" aria-label="Kopiér rabatkoden"><strong id="gf-rf-code">' + esc(res.coupon.code) + '</strong>' + COPY_SVG + '</button>' +
        '<p class="gf-ty__ok" id="gf-ty-ok" role="status" aria-live="polite"></p>' +
        '<p class="gf-ty__hint">Kopiér koden, og brug den ved checkout.</p>' +
        '<p class="gf-ty__fine">Rabatkoden gælder til og med ' + esc(dkDate(res.coupon.expires_at)) + '.<br>Vi har også sendt koden til din mail.</p></div></div>';
    } else if (res.rewardPending) {
      coupon = '<div class="gf-ty__pending"><span class="gf-ty__gift gf-ty__gift--sm">' + GIFT_SVG + '</span><p>Din anmeldelse bliver lige gennemset, og så sender vi din rabatkode på mail.</p></div>';
    }

    // "one more thing": a Trustpilot review (no reward, the same words whatever the rating); replaces the old shop button
    var tp = '<div class="gf-ty__tp"><div class="gf-ty__orn" aria-hidden="true"><i></i>' + HEART_SVG + '<i></i></div>' +
      '<h2 class="gf-ty__tph">Okay, vi lover, det er det sidste... \uD83D\uDE07</h2>' +
      '<p class="gf-ty__tpt">Hvis du har 2 minutter mere, og har lyst, må du meget gerne dele din oplevelse på Trustpilot også. Det hjælper andre med at handle trygt hos os. Vi skal nok lade dig være bagefter. Pinky promise! \uD83E\uDD1E</p>' +
      '<div class="gf-ty__tps" aria-hidden="true"><i>&#9733;</i><i>&#9733;</i><i>&#9733;</i><i>&#9733;</i><i>&#9733;</i></div>' +
      '<a class="gf-ty__btn" href="' + TP_URL + '" target="_blank" rel="noopener"><span>Skriv på Trustpilot</span>' + ARROW_SVG + '</a></div>';

    show('<div class="gf-ty"><h1 class="gf-ty__h">' + head + '</h1>' +
      '<div class="gf-ty__orn" aria-hidden="true"><i></i>' + HEART_SVG + '<i></i></div>' +
      '<p class="gf-ty__lead">' + lead + '</p>' +
      '<div class="gf-ty__card">' + rate + coupon +
      tp + '</div></div>');

    // copy: clicking the code field or the icon copies the real code (clipboard, with a fallback)
    var copy = document.getElementById('gf-rf-copy');
    if (copy) copy.addEventListener('click', function () {
      var code = document.getElementById('gf-rf-code').textContent;
      var ok = document.getElementById('gf-ty-ok');
      var done = function () {
        copy.classList.add('is-copied');
        if (ok) ok.textContent = 'Koden er kopieret';
        setTimeout(function () { copy.classList.remove('is-copied'); if (ok) ok.textContent = ''; }, 2600);
      };
      var fallback = function () {
        var ta = document.createElement('textarea');
        ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (e) { /* ignore */ }
        document.body.removeChild(ta);
        done();
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback); else fallback();
    });
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
  }

  // ----- start --------------------------------------------------------------
  if (!token) {
    message('Linket mangler', 'Brug linket i den mail, vi har sendt dig, for at skrive din anmeldelse.');
    return;
  }
  if (qs.get('afmeld')) { unsubscribeView(); return; }

  fetchJson('/api/public/request?t=' + encodeURIComponent(token))
    .then(function (d) {
      data = d;
      if (d.state === 'reviewed') return message('Du har allerede anmeldt', 'Tak for din anmeldelse. Den betyder rigtig meget for os.');
      st.name = d.firstName || '';
      var pre = Number(qs.get('r'));
      buildBlocks();
      if (pre >= 1 && pre <= 5) st.blocks.forEach(function (b) { b.rating = pre; });
      renderForm();
    })
    .catch(function (e) {
      if (e.status === 404) message('Linket er ikke gyldigt', 'Vi kunne ikke finde din ordre. Brug linket i den nyeste mail fra os, eller skriv til info@glitterfox.dk.');
      else message('Vi kan ikke hente formularen lige nu', 'Prøv igen om et øjeblik.');
    });
})();
